import React from 'react';
import './assets/loading.scss';

const ProductListLoading = () => <div className='no-rows' />;

export default ProductListLoading;
